import { render, staticRenderFns } from "./ObtainModal.vue?vue&type=template&id=08143292"
import script from "./ObtainModal.vue?vue&type=script&lang=js"
export * from "./ObtainModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports